import React from 'react';

const ArrowRight = (props) => {

    return (
        <svg version="1.1" viewBox="0 0 179.4 17.5" width={180} height={17}>
<path fill={props.fill} d="M164.6,0.2c-0.5,0.3-0.7,0.8-0.7,1.3v2.2c0,0.5,0.3,1,0.8,1.3l2.7,1.6L1.5,6.6C0.7,6.6,0,7.3,0,8.1l0,2
	c0,0.8,0.7,1.5,1.5,1.5l164.9,0l-1.7,0.8c-0.5,0.3-0.8,0.8-0.8,1.3v2.2c0,0.5,0.3,1,0.7,1.3s1,0.3,1.5,0.1l12.5-6.4
	c0.5-0.3,0.8-0.8,0.8-1.3V8.7c0-0.5-0.3-1-0.8-1.3l-12.5-7.2C165.7-0.1,165.1-0.1,164.6,0.2z"/>
</svg>


    )
};

export default ArrowRight


